import React from "react";
import primaryLogo from "../assets/danykay-logo.png";
import secondaryLogo from "../assets/danykay-logo-secondary.png";

/**
 * Brand logo.
 * variant="primary"   → big character mark (used on Home hero)
 * variant="secondary" → horizontal wordmark (used in header / nav)
 */
export const Logo = ({ size = "md", variant = "primary", className = "" }) => {
  const src = variant === "secondary" ? secondaryLogo : primaryLogo;

  const primarySizes = {
    sm: "h-10 w-auto",
    md: "h-14 md:h-16 w-auto",
    lg: "h-48 md:h-72 w-auto",
    xl: "h-72 md:h-[28rem] w-auto",
  };
  const secondarySizes = {
    sm: "h-8 w-auto",
    md: "h-10 md:h-12 w-auto",
    lg: "h-14 md:h-16 w-auto",
  };
  const cls =
    variant === "secondary"
      ? secondarySizes[size] ?? secondarySizes.md
      : primarySizes[size] ?? primarySizes.md;

  return (
    <img
      src={src}
      alt={variant === "secondary" ? "dany kay wordmark" : "Dany Kay logo"}
      className={`${cls} select-none ${className}`}
      data-testid={variant === "secondary" ? "brand-logo-secondary" : "brand-logo"}
      draggable={false}
    />
  );
};
